import { render } from "./UserRole.vue?vue&type=template&id=5662e0fc&scoped=true&ts=true"
import script from "./UserRole.vue?vue&type=script&lang=ts"
export * from "./UserRole.vue?vue&type=script&lang=ts"

import "./UserRole.vue?vue&type=style&index=0&id=5662e0fc&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5662e0fc"]])

export default __exports__